import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Button, Icon, Table, Header, Popup, Form, Segment } from 'semantic-ui-react';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoExamTerms = () => <p>Nema prethodnih ispitnih rokova.</p>;

export default class HistoryExamTerms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            academicYear: localStorage.getItem('academicYear') ? localStorage.getItem('academicYear').id ? JSON.parse(localStorage.getItem('academicYear')).id : JSON.parse(localStorage.getItem('academicYear')) : '',
            academicYears: [],
            filterData: [],
            showFilterMode: false,
            showFiltersOnButton: false
        };

        this.getDataToRender = this.getDataToRender.bind(this);

        this.filtersOff = this.filtersOff.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getExamTerms = this.getExamTerms.bind(this);
        this.getExamTermsForAdmin = this.getExamTermsForAdmin.bind(this);
    }

    componentDidMount() {
        if (this.state.academicYear) {
            if (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') {
                this.getExamTermsForAdmin(this.state.academicYear);
            } else {
                this.getExamTerms(this.state.academicYear);
            }
        } else {
            axios.get('/academic-years/current-and-previous/')
                .then(res => {
                    this.setState(
                        {
                            academicYear: res.data.reverse()[0].id
                        },
                        () => { (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') ? this.getExamTermsForAdmin(this.state.academicYear) : this.getExamTerms(this.state.academicYear); }
                    );
                });
        }


        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                const academicYears = res.data.reverse().map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    academicYears,
                    // academicYear: academicYears[0].id
                });
            });
    }

    getExamTerms(academicYear) {
        axios.get(`/exams/terms-for-academic-year/${academicYear}`)
            .then((res) => {
                const data = res.data.map(el => ({
                    ...el,
                    startDatee: moment(el.startDate).format('D. M. YYYY.'),
                    endDatee: moment(el.endDate).format('D. M. YYYY.'),
                    openDate: el.registrationOpeningDate ? moment(el.registrationOpeningDate).format('D. M. YYYY.') : null,
                }

                )).filter(el => el.endDate < moment());
                this.setState({ data, loading: false });
            });
    }

    getExamTermsForAdmin(academicYear) {
        axios.get(`/exams/terms-for-academic-year/${academicYear}/${localStorage.getItem('orgUnit')}`)
            .then((res) => {
                const data = res.data.map(el => ({
                    ...el,
                    startDatee: moment(el.startDate).format('D. M. YYYY.'),
                    endDatee: moment(el.endDate).format('D. M. YYYY.'),
                    openDate: el.registrationOpeningDate ? moment(el.registrationOpeningDate).format('D. M. YYYY.') : null,
                }

                )).filter(el => el.endDate < moment());
                this.setState({ data, loading: false });
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        localStorage.setItem('academicYear', value);
        console.log('value', value);
        if (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') {
            this.getExamTermsForAdmin(value);
        } else {
            this.getExamTerms(value);
        }
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }

    getFilterData(name, sDate, eDate) {
        let docFilter = {};
        if (name) docFilter = { ...docFilter, name };
        if (sDate) {
            let startDate = moment(sDate).format();
            docFilter = { ...docFilter, startDate };
        }
        if (eDate) {
            let endDate = moment(eDate).format();
            docFilter = { ...docFilter, endDate };
        }

        axios.post('/exams/terms', { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    startDatee: moment(el.startDate).format('D. M. YYYY.'),
                    endDatee: moment(el.endDate).format('D. M. YYYY.')
                }));
                this.setState({ filterData: filterData.filter(el => el.endDate < moment()), showFilterMode: !this.state.showFilterMode, showFiltersOnButton: true });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }

    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.state.data;
    }

    render() {
        return (
            <div>
                <Header>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <label>Akademska godina</label>
                                <Form.Dropdown
                                    placeholder="Odaberite akademsku godinu"
                                    search
                                    fluid
                                    selection
                                    options={this.state.academicYears}
                                    onChange={this.handleInputChange}
                                    value={this.state.academicYear}
                                    name="academicYear"

                                />
                            </Form.Field>
                            <Form.Field />
                            <Form.Field />
                            <Form.Field />
                        </Form.Group>
                    </Form>
                </Header>


                {this.getDataToRender().length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Naziv ispitnog roka</Table.HeaderCell>
                                <Table.HeaderCell>Datum početka</Table.HeaderCell>
                                <Table.HeaderCell>Datum kraja</Table.HeaderCell>
                                <Table.HeaderCell>
                                    <Header as="h4" image>
                                        <Header.Content>
                                            Početak prijave ispita
                                            <Header.Subheader>(datum/broj dana prije ispita)</Header.Subheader>
                                        </Header.Content>
                                    </Header></Table.HeaderCell>
                                <Table.HeaderCell>
                                    <Header as="h4" image>
                                        <Header.Content>
                                            Kraj  prijave ispita
                                            <Header.Subheader>(broj dana prije ispita)</Header.Subheader>
                                        </Header.Content>
                                    </Header>
                                </Table.HeaderCell>
                                <Table.HeaderCell>Napomena</Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.getDataToRender().map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle" width={1}>
                                        {(index + 1)}.
                                    </Table.Cell >
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {el.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.startDatee}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.endDatee}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.registrationOpeningDays ? el.registrationOpeningDays : el.registrationOpeningDate ? moment(el.registrationOpeningDate).format('D. M. YYYY.') : ''}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.registrationClosing}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.comment}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle">
                                        <Popup
                                            content="Ispiti"
                                            position="top center"
                                            trigger={
                                                <Link to={{ pathname: '/ispitni-rokovi/ispiti', state: { id: el.id, name: el.name } }}>
                                                    <Button
                                                        basic
                                                        circular
                                                        icon="copy outline"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => {
                                                            localStorage.setItem('history', true);
                                                            localStorage.removeItem('examsFilters'); // Resetovanje filtera za ispite
                                                        }}
                                                    />
                                                </Link>}
                                        />
                                        <Popup
                                            content="Statistika"
                                            position="top center"
                                            trigger={
                                                <Link to={{ pathname: '/ispitni-rokovi/statistika', state: { id: el.id, name: el.name } }}>
                                                    <Button
                                                        basic
                                                        circular
                                                        icon="chart bar"
                                                        size="small"
                                                        color="green"
                                                    />
                                                </Link>
                                            }
                                        />
                                    </Table.Cell>
                                </Table.Row>))
                            }
                        </Table.Body>
                    </Table>
                    : <NoExamTerms />
                }

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/HistoryExamTerms.js